import _asyncToGenerator from "/opt/build/repo/frontend/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/opt/build/repo/frontend/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/frontend/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/opt/build/repo/frontend/node_modules/@babel/runtime/regenerator/index.js";

var __classPrivateFieldSet = this && this.__classPrivateFieldSet || function (receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};

var __classPrivateFieldGet = this && this.__classPrivateFieldGet || function (receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};

var _EmittersPlugin_engine;

import { CircleShape } from "./Shapes/Circle/CircleShape";
import { Emitter } from "./Options/Classes/Emitter";
import { Emitters } from "./Emitters";
import { ShapeManager } from "./ShapeManager";
import { SquareShape } from "./Shapes/Square/SquareShape";
import { isInArray } from "../../Utils";

var EmittersPlugin = /*#__PURE__*/function () {
  function EmittersPlugin(engine) {
    _classCallCheck(this, EmittersPlugin);

    _EmittersPlugin_engine.set(this, void 0);

    __classPrivateFieldSet(this, _EmittersPlugin_engine, engine, "f");

    this.id = "emitters";
  }

  _createClass(EmittersPlugin, [{
    key: "getPlugin",
    value: function getPlugin(container) {
      return new Emitters(__classPrivateFieldGet(this, _EmittersPlugin_engine, "f"), container);
    }
  }, {
    key: "needsPlugin",
    value: function needsPlugin(options) {
      var _a, _b, _c;

      if (options === undefined) {
        return false;
      }

      var emitters = options.emitters;
      return emitters instanceof Array && !!emitters.length || emitters !== undefined || !!((_c = (_b = (_a = options.interactivity) === null || _a === void 0 ? void 0 : _a.events) === null || _b === void 0 ? void 0 : _b.onClick) === null || _c === void 0 ? void 0 : _c.mode) && isInArray("emitter", options.interactivity.events.onClick.mode);
    }
  }, {
    key: "loadOptions",
    value: function loadOptions(options, source) {
      var _a, _b;

      if (!this.needsPlugin(options) && !this.needsPlugin(source)) {
        return;
      }

      var optionsCast = options;

      if (source === null || source === void 0 ? void 0 : source.emitters) {
        if ((source === null || source === void 0 ? void 0 : source.emitters) instanceof Array) {
          optionsCast.emitters = source === null || source === void 0 ? void 0 : source.emitters.map(function (s) {
            var tmp = new Emitter();
            tmp.load(s);
            return tmp;
          });
        } else {
          var emitterOptions = optionsCast.emitters;

          if ((emitterOptions === null || emitterOptions === void 0 ? void 0 : emitterOptions.load) === undefined) {
            optionsCast.emitters = emitterOptions = new Emitter();
          }

          emitterOptions.load(source === null || source === void 0 ? void 0 : source.emitters);
        }
      }

      var interactivityEmitters = (_b = (_a = source === null || source === void 0 ? void 0 : source.interactivity) === null || _a === void 0 ? void 0 : _a.modes) === null || _b === void 0 ? void 0 : _b.emitters;

      if (interactivityEmitters) {
        if (interactivityEmitters instanceof Array) {
          optionsCast.interactivity.modes.emitters = interactivityEmitters.map(function (s) {
            var tmp = new Emitter();
            tmp.load(s);
            return tmp;
          });
        } else {
          var _emitterOptions = optionsCast.interactivity.modes.emitters;

          if ((_emitterOptions === null || _emitterOptions === void 0 ? void 0 : _emitterOptions.load) === undefined) {
            optionsCast.interactivity.modes.emitters = _emitterOptions = new Emitter();
          }

          _emitterOptions.load(interactivityEmitters);
        }
      }
    }
  }]);

  return EmittersPlugin;
}();

_EmittersPlugin_engine = new WeakMap();
export function loadEmittersPlugin(_x) {
  return _loadEmittersPlugin.apply(this, arguments);
}

function _loadEmittersPlugin() {
  _loadEmittersPlugin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(engine) {
    var plugin;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!engine.emitterShapeManager) {
              engine.emitterShapeManager = new ShapeManager(engine);
            }

            if (!engine.addEmitterShape) {
              engine.addEmitterShape = function (name, shape) {
                var _a;

                (_a = engine.emitterShapeManager) === null || _a === void 0 ? void 0 : _a.addShape(name, shape);
              };
            }

            plugin = new EmittersPlugin(engine);
            _context.next = 5;
            return engine.addPlugin(plugin);

          case 5:
            engine.addEmitterShape("circle", new CircleShape());
            engine.addEmitterShape("square", new SquareShape());

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _loadEmittersPlugin.apply(this, arguments);
}

export * from "./EmittersEngine";